import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import GalleryLanding from "../views/GalleryLanding";

export default function Gallery() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  useEffect(() => {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<GalleryLanding />);
    } else {
      setView(null);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
